<div class="loadingOverlay" *ngIf="mainLoader">
  <div class="overlay-content">
    <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <g transform="rotate(208.756 50 50)">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;0 50 50"
          keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
        <path fill="#85ffbd"
          d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
        </path>
        <path fill="#316598"
          d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
        </path>
        <path fill="#a4bcc2"
          d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
        </path>
      </g>
    </svg>
  </div>
</div>

<div class="wrapper" [ngClass]="{'sidebar-active': openSidebar}">
  <!-- Sidebar -->

  <nav class="navbar fixed-top navbar-expand-md ok-top-nav nav-clr">
    <!-- <hr class="upper-line"> -->
    <button class="navbar-toggler top-nav-toggler" type="button" data-toggle="collapse" data-target="#nav-content"
      aria-controls="nav-content" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>


    <div class="left-navigation-part">



      <div class="logo-box parallelogram navbar-brand">
        <a class="cursor" (click)="navigateToDashboard()">
          <img src="../../../assets/img/ezicrypto.png">
        </a>
      </div>



      <div class="sidebar-toggle-wrapper" (click)="closeSidebar()">


        <div class="sidebar-toggle">
          <button type="button" class="toggle-btn-sidebar">
            <i class="fas fa-bars"></i>
          </button>
        </div>

      </div>


    </div>




    <div class="collapse navbar-collapse right-aligned " id="nav-content">
      <ul class="social-icon-list">
        <li class="text-center mr-2">
          <!-- <a href="https://www.facebook.com/piptle/" class="icon-borders" target="_blank"> -->
          <a class="icon-borders" >

              <img src="../../../assets//img//PIPTLE-Facebook-F-Icon.png" alt="fb-icon" class="icon-img">
          </a>
        </li>
        <li class="text-center mr-2">
          <!-- <a href="https://twitter.com/piptleit" class="icon-borders" target="_blank"> -->
          <a class="icon-borders" target="_blank">
            <!-- <img src="../../../assets//img/twitter-ico.png" alt="twitter-icon"> -->
              <img src="../../../assets//img//PIPTLE-TwitterIcon.png" alt="twitter-icon" class="icon-img">
          </a>
        </li>
        <li class="text-center mr-2">
          <!-- <a href="https://www.instagram.com/piptleit/" target="_blank" class="icon-borders"> -->
          <a class="icon-borders" >

            <!-- <img src="../../../assets//img/insta-ico.png" alt="instagram-icon"> -->
              <img src="../../../assets//img//PIPTLE-InstagramIcon.png" alt="instagram-icon" class="icon-img">
          </a>
        </li>
        <li class="text-center mr-2">
          <!-- <a href="https://t.me/piptler" target="_blank" class="icon-borders"> -->
          <a class="icon-borders" >

            <!-- <img src="../../../assets//img/insta-ico.png" alt="instagram-icon"> -->
              <img src="../../../assets//img//telegram icon.png" alt="telegram-icon" class="icon-telegram">
          </a>
        </li>
        <li class="text-center mr-2" (click)="switchLanguage('en')" >
          <a target="_blank" class="icon-borders">
            <!-- <img src="../../../assets//img/insta-ico.png" alt="instagram-icon"> -->
              <img src="../../../assets//img//AussieFlag.png" alt="fb-icon" class="icon-flag">
          </a>
        </li>
        <!-- <li style="vertical-align: middle;" class='img-list-item'>
          <div id='language' class="dropdown">
            <button class="btn btn-default dropdown-toggle custom-style" type="button" id="dropdownMenu1"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <span class="caret"></span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li (click)="switchLanguage('en')" class="rad-50 pd-2">
                <a href="javascript:void(0)" class="rad-50">
                  <img class="rad-50" src="../../../assets/img/eng.png" width="32" height="32" /></a>
              </li>
              <li (click)="switchLanguage('es')" class="rad-50 pd-2">
                <a href="javascript:void(0)" class="rad-50">
                  <img class="rad-50" src="../../../assets/img/esp.png" width="32" height="32" /></a>
              </li>
            </ul>
          </div> -->
          <!-- <select id='language' class="language-select" (change)="switchLanguage($event.target.value)" [(ngModel)]="selectedLang">

                <option value="en">EN</option>
                <option value="es">ES</option>
          
              </select> -->
         <!-- </li> -->
      </ul>
      <!-- <div class="search-bar">
                <div class='search-wrapper'>
                    <div class='btn'>
                        <button class="search">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                    <input type="text" class="input-search" placeholder="Search">
                </div>
            </div>

            <ul class="navbar-nav left-notifications-list ml-auto">

                <li class="nav-item">

                    <div class="notifications">
                        
                        <a class="notification-btn" href="mailto:info@cryptoxchange.com">
                            <img src="../../../assets/img/messages.png" alt="message icon">
                        </a>
                    </div>


                    <select class="language-select" (change)="switchLanguage($event.target.value)">    

                        <option value="en">EN</option>
                        <option value="de">DE</option>

                    </select>



                </li>
               
                <li class="nav-item">




                    <div class="dropdown">
                        <div class="notification-count" *ngIf="notificationCount != 0">
                            <p class="count">{{notificationCount}}</p>
                        </div>
                        <button type="button" class="btn dropdown-toggle notification-btn" data-toggle="dropdown"
                            (click)="fetchNotifications()">
                            <img src="../../../assets/img/notification.png" alt="notification icon">
                        </button>
                        <div class="dropdown-menu notifications-tab">

                            <div class="pointy-up">

                            </div>




                            <ul class="notifications-list">

                                <li class="no-hover" *ngIf="notificationsLoader">
                                    <div class="box-loader">
                                        <div class="center-loader">
                                            <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                                preserveAspectRatio="xMidYMid">
                                                <g transform="rotate(208.756 50 50)">
                                                    <animateTransform attributeName="transform" type="rotate"
                                                        repeatCount="indefinite" values="360 50 50;0 50 50" keyTimes="0;1"
                                                        dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
                                                    <path fill="#85ffbd" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"></path>
                                                    <path fill="#316598" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"></path>
                                                    <path fill="#a4bcc2" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </li>

                                <div class="clearfix" *ngIf="notificationList.length == 0">
                                    <div class="not-inner">
                                        <p class="no-notifications text-centered">No Notifications</p>
                                    </div>
                                </div>

                                <ng-container *ngFor="let nott of notificationList">


                                    <li *ngIf="nott.NotificationType == 'WIRE_TRANSFER_APPROVE_REJECTION'" [ngClass]="{'unreadNotification': nott.IsRead==false}"
                                        (click)="updateNotificationStatus(nott._id)">
                                        <div class="clearfix">
                                            <div class="not-icon-left">
                                                <svg width="19px" height="15px" viewBox="0 0 19 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">

                                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                        <g id="Dashboard" transform="translate(-19.000000, -312.000000)"
                                                            fill="#8E949C" fill-rule="nonzero">
                                                            <g id="Navigation" transform="translate(0.000000, 70.000000)">
                                                                <g id="transfer" transform="translate(19.000000, 242.000000)">
                                                                    <path d="M18.8013361,4.97239972 L14.0512541,0.199623099 C13.7862098,-0.0666076039 13.3565565,-0.0665277027 13.0915917,0.199782901 C12.9643975,0.327624776 12.8929477,0.500930416 12.8929079,0.681706816 L12.8929079,2.7271768 L8.1428259,2.7271768 C7.7680423,2.7271768 7.4642314,3.03243923 7.4642314,3.40901345 C7.4642314,3.78558767 7.7680423,4.09085009 8.1428259,4.09085009 L13.5715024,4.09085009 C13.946286,4.09085009 14.2500969,3.78558767 14.2500969,3.40901345 L14.2500969,2.32759105 L17.3620811,5.45444348 L14.2500969,8.58129592 L14.2500969,7.49991347 C14.2500969,7.12333925 13.946286,6.81807683 13.5715024,6.81807683 L6.10708215,6.81807683 L6.10708215,4.77260684 C6.10700263,4.39603262 5.80311221,4.09085009 5.42836837,4.09093 C5.24849132,4.09096995 5.07596999,4.16276115 4.948736,4.29056307 L0.198693759,9.06333969 C-0.066231253,9.32961034 -0.066231253,9.76119652 0.198693759,10.0274272 L4.94877577,14.8002038 C5.07600975,14.9280857 5.24857084,14.9999568 5.42852741,14.9999967 C5.51771048,15.0002764 5.60609834,14.9826582 5.68840282,14.9481808 C5.94191654,14.8425515 6.10716167,14.593939 6.10708215,14.3181601 L6.10708215,12.2726901 L10.8571642,12.2726901 C11.2319478,12.2726901 11.5357587,11.9674277 11.5357587,11.5908534 C11.5357587,11.2142792 11.2319478,10.9090168 10.8571642,10.9090168 L5.42852741,10.9090168 C5.0537438,10.9090168 4.7499329,11.2142792 4.7499329,11.5908534 L4.7499329,12.6722359 L1.63794869,9.54538346 L4.7499329,6.41853102 L4.7499329,7.49991347 C4.7499329,7.87648769 5.0537438,8.18175012 5.42852741,8.18175012 L12.8929079,8.18175012 L12.8929079,10.2272201 C12.8929874,10.6037943 13.1968778,10.9089768 13.5716217,10.9088969 C13.7514987,10.908857 13.9240201,10.8370658 14.0512541,10.7092639 L18.8013361,5.93648725 C19.0662213,5.6702166 19.0662213,5.23863042 18.8013361,4.97239972 Z"
                                                                        id="Shape"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div class="not-inner">
                                                <p class="notification-line">{{nott.NotificationText}}</p>
                                            </div>
                                            <div class="abs-time">
                                                {{nott.CreatedOnUTC}}
                                            </div>
                                        </div>
                                    </li>

                                    <li *ngIf="nott.NotificationType == 'Transaction_Confirmation'" [ngClass]="{'unreadNotification': nott.IsRead==false}"
                                        (click)="updateNotificationStatus(nott._id)">
                                        <div class="clearfix">
                                            <div class="not-icon-left">
                                                <img src="../../../assets/img/transaction.png">
                                            </div>
                                            <div class="not-inner">
                                                <p class="notification-line">{{nott.NotificationText}}</p>
                                            </div>
                                            <div class="abs-time">
                                                {{nott.CreatedOnUTC}}
                                            </div>
                                        </div>
                                    </li>
                                    <li *ngIf="nott.NotificationType == 'KYC_Approval'" [ngClass]="{'unreadNotification': nott.IsRead==false}"
                                        (click)="updateNotificationStatus(nott._id)">
                                        <div class="clearfix">
                                            <div class="not-icon-left">
                                                <img src="../../../assets/img/kyc.png">
                                            </div>
                                            <div class="not-inner">
                                                <p class="notification-line">{{nott.NotificationText}}</p>
                                            </div>
                                            <div class="abs-time">
                                                {{nott.CreatedOnUTC}}
                                            </div>
                                        </div>
                                    </li>
                                    <li *ngIf="nott.NotificationType == 'ICO_Stage_Updation'" [ngClass]="{'unreadNotification': nott.IsRead==false}"
                                        (click)="updateNotificationStatus(nott._id)">
                                        <div class="clearfix">
                                            <div class="not-icon-left">
                                                <img src="../../../assets/img/ico-stage.png">
                                            </div>
                                            <div class="not-inner">
                                                <p class="notification-line">{{nott.NotificationText}}</p>
                                            </div>
                                            <div class="abs-time">
                                                {{nott.CreatedOnUTC}}
                                            </div>
                                        </div>
                                    </li>
                                    <li *ngIf="nott.NotificationType === 'AFFILIATION_TRANSACTION'" [ngClass]="{'unreadNotification': nott.IsRead==false}"
                                        (click)="updateNotificationStatus(nott._id)">
                                        <div class="clearfix">
                                            <div class="not-icon-left">
                                                <img src="../../../assets/img/reward.png">
                                            </div>
                                            <div class="not-inner">
                                                <p class="notification-line">{{nott.NotificationText}}</p>
                                            </div>
                                            <div class="abs-time">
                                                {{nott.CreatedOnUTC}}
                                            </div>
                                        </div>
                                    </li>

                                    <li *ngIf="nott.NotificationType === 'AFFILIATION_REGISTRATION'" [ngClass]="{'unreadNotification': nott.IsRead==false}"
                                        (click)="updateNotificationStatus(nott._id)">
                                        <div class="clearfix">
                                            <div class="not-icon-left">
                                                <img src="../../../assets/img/affiliate.png">
                                            </div>
                                            <div class="not-inner">
                                                <p class="notification-line">{{nott.NotificationText}}</p>
                                            </div>
                                            <div class="abs-time">
                                                {{nott.CreatedOnUTC}}
                                            </div>
                                        </div>
                                    </li>
                                </ng-container>

                                <div class="clearfix">
                                    <div class="not-inner">
                                        <p class="see-all-btn text-centered" style="cursor:pointer" (click)="navigateToNotificationsList()">See
                                            All
                                        </p>
                                    </div>
                                </div>

                            </ul>

                        </div>
                    </div>


                </li>

                <li class="nav-item">
                    <div class="notifications">
                        <button class="notification-btn" onclick="zE.activate();">
                            <img src="../../../assets/img/chat.png" alt="chat icon">
                        </button>
                    </div>
                </li>

            </ul>
            <ul class="navbar-nav">
                <li class="nav-item p-bar">
                    <div class="dropdown profile-dropdown-wrapper full-screen-profile">
                        <button type="button" class="dropdown-toggle profile-dropdown-btn" data-toggle="dropdown">

                            <div class="clearfix">


                                <div class="left-image">
                                    <div class="rounded-image-box">
                                        <img src="../../../assets/img/shirley.png">
                                    </div>
                                </div>
                                <div class="profile-name">
                                    <p class="actual-name">{{userObject.UserName}}
                                        <span class='icon-drop'>
                                            <i class="fas fa-chevron-down"></i>
                                        </span>
                                    </p>
                                </div>

                            </div>
                        </button>
                        <div class="dropdown-menu">
                            <ul class="profile-list">
                                <li class="cursor" (click)="NavigateToSettings()">
                                    <div class="clearfix cursor">
                                        <div class="left-icon">
                                            <svg class="ver-align-none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                                width="20px" height="20px">
                                                <image x="0px" y="0px" width="20px" height="20px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBhoMHQ42cuoNAAABWUlEQVQoz2XSvWtVQRAF8JOoiBYhiC/BWGiIRSzUWmxEEAk2RhAbTWMhmIekUATBLohYxErBSv0T7GzsLGJIY4IoUdEmifgBFhEFhZ/FW9+792am2D0zZ8/uHLZPGnE943mXO81y1HO/Tow26ukv/B2ZzWCS6YLbSVp5kIGm4jN8tKYXX61i/r9iZ5mpEF56ZLGCr1aJsQLeOFjwoCWwUleMD93iMt4aEQtY7xG32u4WOF6KT7EqDoM5ezvEG+Utn7tWnADbxKfSOyL9GS7jf0nyPOeSXEuSDCX5VnoDSW/iH6JN16K74nvZj0ls0acNzoonFWMumsOV+tQL2NASu4257C+YMKtVJ74GP00WfLKoHqv7eKFy4S/v8diZgo/WFe/hlReVA1NO9cxR+WaX7BHnS3NGxE3wxz6b/uNOv8F4wbfBhukmMXY5ZKiCH2LZ6c3EZg6774D8AxlK7Tt5GVv7AAAAAElFTkSuQmCC" />
                                            </svg>
                                        </div>
                                        <div class="right-name">
                                            <p class="text-color">Profile</p>
                                        </div>
                                    </div>
                                </li>




                                <li (click)="navigateToFaqs()">

                                    <div class="clearfix cursor">
                                        <div class="left-icon">
                                            <svg class="ver-align-none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                                width="18px" height="18px">
                                                <image x="0px" y="0px" width="18px" height="18px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBhoMIQis4jbHAAABA0lEQVQoz2WSsUoDQRCGvztMJYLChfRCCi2ECGcRLNOmsLDzCaxtbC1EfAJbBQUfwE5JmxAQAjHN2ahIGgshNgnmfovcHjPx32bnm5/dmZ2NhNEOTRKmZDwxMVxhHepDVndKQi5YHsrkXLcaFvuWNXXMCQsS1A6mM3cNQldl9K11gTb040y5chefC3RkQLcoNjPsRcTsm1YnfAGr1AzbZiumbkCLCyBlzT4etZhfB3pAipdiRg48A7tLpnd0YIrMhNCr664vUEXjEtwL1eV1snjM4xLcCKHUWN60EsZyXaDp0lByNeyAL/VfY236X4AaejSGT50qCrnIfbqEParMGDGw+A+3VnAmUZWGhgAAAABJRU5ErkJggg==" />
                                            </svg>
                                        </div>
                                        <div class="right-name">
                                            <p class="text-color">FAQ</p>
                                        </div>
                                    </div>




                                </li>


                                <li (click)="logout()">

                                    <div class="clearfix cursor">
                                        <div class="left-icon">
                                            <svg class="ver-align-none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                                width="18px" height="15px">
                                                <image x="0px" y="0px" width="18px" height="15px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAMAAADeWG8gAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAY1BMVEX///+jssf///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+jsseNoU6pAAAAH3RSTlMAABSmowTA/M0M2xHtJPdDBVb1OgLnHdUJCga3C5gH9fLnCAAAAAFiS0dEAIgFHUgAAAAHdElNRQfiBhoMIR3BP9IsAAAAX0lEQVQY02XPVw7AIAwDULro3nua+5+yUklABX9Fz1KUCCHwRdiEiiliAmI9JJCGuEyR5ZZAKUqPUNUeoWk7l4DepWGcHJoXd9e6/e8C5E6D0nLgpO4yP97m74DpIXgB318QYzdytmQAAAAASUVORK5CYII=" />
                                            </svg>
                                        </div>
                                        <div class="right-name">
                                            <p class="text-color">Logout</p>
                                        </div>
                                    </div>


                                </li>

                            </ul>
                        </div>
                    </div>
                </li>
            </ul> -->
    </div>

  </nav>


  <!--   -->

  <div class=" no-printme" >
    <nav id="sidebar" >
      <!-- <img src="../../../assets/img/dashboard-img.png" class="myimg" alt="" srcset=""> -->

      <div style="height: 100%; "   class="sidebar-bg">  
        <!-- <div class="close-sidebar" (click)="closeSidebar()">
        <button class="close-sidebar-btn">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" width="20px" height="20px" viewBox="0 0 357 357" style="enable-background:new 0 0 357 357;"
            xml:space="preserve">
            <g>
              <g id="close">
                <polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 
                           214.2,178.5 		" />
              </g>
            </g>
  
          </svg>
  
        </button>
      </div> -->
        <div class="sidebar-header">
          <p>
          <p>
        </div>
  
        <ul class="list-unstyled components">
  
          <li id="dash-nav" class="active" (click)="navigateToDashboard()">
            <a>
              <span class="side-icons">
                <!-- <svg width="19px" height="13px" viewBox="0 0 19 13" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
  
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Wire-transfer-popup" transform="translate(-20.000000, -157.000000)" fill="#8E949C"
                      fill-rule="nonzero">
                      <g id="Navigation" transform="translate(0.000000, 70.000000)">
                        <g id="dashboard" transform="translate(20.000000, 87.000000)">
                          <path
                            d="M16.2176454,2.76235966 C14.4233354,0.981037032 12.0375903,0 9.50007248,0 C6.96255465,0 4.5768095,0.981037032 2.78249957,2.76235966 C0.988189597,4.54382623 0,6.91215934 0,9.43131048 C0,10.1243829 0.0761037818,10.8158722 0.226281929,11.4866385 C0.31296779,11.8734696 0.425601391,12.2585737 0.560993678,12.6313016 C0.643475682,12.8585361 0.859320521,13 1.08937142,13 C1.15271875,13 1.21693587,12.9892067 1.2799933,12.9667567 C1.57179697,12.8621339 1.72298985,12.5426528 1.61774916,12.2529613 C1.4984474,11.9245578 1.39929503,11.585361 1.3230463,11.2445812 C1.23099694,10.8331415 1.17112863,10.4127793 1.1428615,9.98896317 L2.86991022,9.98896317 C3.18012373,9.98896317 3.43162865,9.73927869 3.43162865,9.43131048 C3.43162865,9.12334228 3.18012373,8.87365776 2.86991022,8.87365776 L1.14271655,8.87365776 C1.21708082,7.76482831 1.51120384,6.7148582 1.98232257,5.766201 L3.47729093,6.6231873 C3.56571631,6.67384375 3.66225938,6.6980207 3.75764278,6.6980207 C3.9517437,6.6980207 4.14062607,6.59800298 4.2445621,6.41912237 C4.39966889,6.15231255 4.30761953,5.81124493 4.0390094,5.65726085 L2.54534566,4.80113799 C3.15330621,3.90400071 3.93246408,3.13048243 4.83599727,2.52692232 L5.69850692,4.00977485 C5.80244295,4.18879932 5.99132532,4.28881704 6.18542623,4.28881704 C6.28066468,4.28881704 6.37735271,4.2646401 6.46577809,4.21398365 C6.73453317,4.05999956 6.82658253,3.71893195 6.67133082,3.45212213 L5.80824133,1.96797438 C6.76381503,1.50026567 7.82129533,1.20827153 8.93820906,1.13458941 L8.93820906,2.84913763 C8.93820906,3.15710584 9.18971398,3.40679035 9.49992752,3.40679035 C9.81014107,3.40679035 10.0617909,3.15710584 10.0617909,2.84913763 L10.0617909,1.13458941 C11.1785597,1.20841543 12.236185,1.50026567 13.1917587,1.96797438 L12.3285242,3.45226603 C12.1734174,3.71893195 12.2654668,4.05999956 12.5342219,4.21398365 C12.6226473,4.2646401 12.7191904,4.28881704 12.8145738,4.28881704 C13.0086747,4.28881704 13.1974121,4.18879932 13.3014931,4.00991875 L14.1638577,2.52692232 C15.0675359,3.13048243 15.8466938,3.90400071 16.4546543,4.80113799 L14.9609906,5.65726085 C14.6922355,5.81124493 14.6001862,6.15231255 14.7552929,6.41912237 C14.8593739,6.59800298 15.0482563,6.6980207 15.2423572,6.6980207 C15.3375957,6.6980207 15.4342837,6.67398766 15.5227091,6.6231873 L17.0176774,5.7663449 C17.4887962,6.7148582 17.7829192,7.76482831 17.8572834,8.87365776 L16.1300898,8.87365776 C15.8197313,8.87365776 15.5682264,9.12334228 15.5682264,9.43131048 C15.5682264,9.73927869 15.8197313,9.98896317 16.1300898,9.98896317 L17.8571385,9.98896317 C17.8303209,10.3901853 17.7753813,10.7885293 17.6914497,11.1785264 C17.622014,11.5005978 17.532284,11.8218057 17.424579,12.1330839 C17.3238321,12.4245024 17.4800985,12.7416809 17.7734968,12.8416986 C18.066895,12.9415724 18.386531,12.7865809 18.4872779,12.4953063 C18.6094788,12.1418624 18.7113854,11.7773374 18.7900985,11.4118051 C18.9294047,10.764784 19,10.098479 19,9.43131048 C19.000145,6.91215934 18.0119554,4.54382623 16.2176454,2.76235966 Z"
                            id="Shape"></path>
                          <path
                            d="M12.9797167,6.18880338 L10.4694241,8.90051238 C10.2286196,8.76297736 9.95028903,8.68392899 9.65387912,8.68392899 C8.74186037,8.68392899 8,9.42780603 8,10.3419645 C8,11.2562753 8.74186037,12 9.65387912,12 C10.565746,12 11.3077583,11.2562753 11.3077583,10.3419645 C11.3077583,10.1601076 11.2778286,9.98510458 11.2235906,9.82122012 L13.842815,6.9917763 C14.064021,6.75280349 14.0500436,6.37934192 13.8116699,6.15758005 C13.5732962,5.93581819 13.2009227,5.94983057 12.9797167,6.18880338 Z M9.5,11 C9.22433037,11 9,10.7756339 9,10.4999203 C9,10.2242067 9.22433037,10 9.5,10 C9.77566967,10 10,10.2242067 10,10.4999203 C10,10.7756339 9.77566967,11 9.5,11 Z"
                            id="Shape"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> -->
                 <span class="img-borders"> <img src="../../../assets/img/PIPTLE-DashboardICON.png" class="sidebar-img" alt="">
                 </span>
              </span> {{ 'Dashboard' | translate }}</a>
          </li>
  
          <li id="ico-nav" (click)="navigateToICO()">
            <a>
              <span class="side-icons">
                <!-- <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
  
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Wire-transfer-popup" transform="translate(-21.000000, -207.000000)" fill="#8E949C"
                      fill-rule="nonzero">
                      <g id="Navigation" transform="translate(0.000000, 70.000000)">
                        <g id="Group-2" transform="translate(21.000000, 137.000000)">
                          <g id="files">
                            <path
                              d="M1.04615315,15.4062508 L1.04615315,1.59375768 C1.04615315,1.30034181 1.28032799,1.06250795 1.56922973,1.06250795 L9.41537835,1.06250795 L9.41537835,3.18750689 C9.41537835,3.77430542 9.88376073,4.25000636 10.4615315,4.25000636 L12.5538378,4.25000636 L12.5538378,5.84375556 L13.599991,5.84375556 L13.599991,3.71875662 C13.6008083,3.5775438 13.5462121,3.44180949 13.4482987,3.34156931 L10.3098393,0.1540709 C10.2111413,0.0546275901 10.0774952,-0.000788397876 9.93845493,8.47672636e-06 L1.56922973,8.47672636e-06 C0.702557225,8.47672636e-06 0,0.71357648 0,1.59375768 L0,15.4062508 C0,16.2864652 0.702557225,17 1.56922973,17 L5.23076575,17 L5.23076575,15.9375005 L1.56922973,15.9375005 C1.28036069,15.9375005 1.04615315,15.6996667 1.04615315,15.4062508 Z"
                              id="Shape"></path>
                            <path
                              d="M14.875,8.5 C13.7014023,8.5 12.75,9.41334625 12.75,10.54 L12.75,11.56 C12.75,12.6866537 13.7014023,13.6 14.875,13.6 C16.0485977,13.6 17,12.6866537 17,11.56 L17,10.54 C17,9.41334625 16.0485977,8.5 14.875,8.5 Z M15.9375,11.56 C15.9375,12.1233269 15.4617988,12.58 14.875,12.58 C14.2882012,12.58 13.8125,12.1233269 13.8125,11.56 L13.8125,10.54 C13.8125,9.97667312 14.2882012,9.52 14.875,9.52 C15.4617988,9.52 15.9375,9.97667312 15.9375,10.54 L15.9375,11.56 Z"
                              id="Shape"></path>
                            <path
                              d="M9.775,9.52 C10.3617988,9.52 10.8375,9.97667312 10.8375,10.54 L11.9,10.54 C11.9,9.41334625 10.9485977,8.5 9.775,8.5 C8.60140234,8.5 7.65,9.41334625 7.65,10.54 L7.65,11.56 C7.65,12.6866537 8.60140234,13.6 9.775,13.6 C10.9485977,13.6 11.9,12.6866537 11.9,11.56 L10.8375,11.56 C10.8375,12.1233269 10.3617988,12.58 9.775,12.58 C9.18820117,12.58 8.7125,12.1233269 8.7125,11.56 L8.7125,10.54 C8.7125,9.97667312 9.18820117,9.52 9.775,9.52 Z"
                              id="Shape"></path>
                            <rect id="Rectangle-path" x="5.95" y="8.5" width="1" height="5.1"></rect>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> -->
              
                <span class="img-borders"> <img src="../../../assets/img/PIPTLE-ILO-sideicon.png" class="sidebar-img" alt="">
                </span>
              </span>{{ 'ICO Information' | translate }}</a>
          </li>
  
          <li id="piptle-wallet-nav" (click)="navigateToPiptleWallet()">
            <a>
              <span class="side-icons">
  
                <span class="img-borders"> <img src="../../../assets/img/PIPTLE-WalletICON.png" class="sidebar-img" alt="">
                </span>
  
              </span> {{ 'My Pip Wallet' | translate }}</a>
          </li>
  
          <li id="wallet-nav" (click)="navigateToWallet()">
            <a>
              <span class="side-icons">
  
                <!-- <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
  
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Dashboard" transform="translate(-18.000000, -259.000000)" fill="#8E949C" fill-rule="nonzero">
                      <g id="Navigation" transform="translate(0.000000, 70.000000)">
                        <g id="buy-tokens" transform="translate(18.000000, 189.000000)">
                          <g id="Group-4">
                            <path
                              d="M14.5,16 C13.676259,16 13,16.676259 13,17.5 C13,18.323741 13.676259,19 14.5,19 C15.323741,19 16,18.323741 16,17.5 C16,16.676259 15.323741,16 14.5,16 Z M15.2482014,17.5 C15.2482014,17.9136691 14.9100719,18.2517986 14.4964029,18.2517986 C14.0827338,18.2517986 13.7446043,17.9136691 13.7446043,17.5 C13.7446043,17.0863309 14.0827338,16.7482014 14.4964029,16.7482014 C14.9496403,16.7517986 15.2877698,17.0899281 15.2482014,17.5 Z"
                              id="Shape"></path>
                            <path
                              d="M8.5,16 C7.67625899,16 7,16.676259 7,17.5 C7,18.323741 7.67625899,19 8.5,19 C9.32374101,19 10,18.323741 10,17.5 C10,16.676259 9.32733813,16 8.5,16 Z M8.5,18.2517986 C8.08633094,18.2517986 7.74820144,17.9136691 7.74820144,17.5 C7.74820144,17.0863309 8.08633094,16.7482014 8.5,16.7482014 C8.91366906,16.7482014 9.25179856,17.0863309 9.25179856,17.5 C9.25179856,17.9136691 8.91366906,18.2517986 8.5,18.2517986 Z"
                              id="Shape"></path>
                            <path
                              d="M16.1673469,5.59085511 C16.3346939,5.13776722 16.4244898,4.65142518 16.4244898,4.14014252 C16.4244898,1.85391924 14.6040816,0 12.3591837,0 C10.1142857,0 8.29387755,1.85391924 8.29387755,4.14014252 C8.29387755,4.65142518 8.38367347,5.14192399 8.55102041,5.59085511 L5.55102041,5.59085511 L3.95918367,0.0457244656 L0,0.0457244656 L0,0.868764846 L3.31836735,0.868764846 L7.10612245,14 L16.5510204,14 L20,5.59085511 L16.1673469,5.59085511 Z M12.3632653,0.868764846 C14.1387755,0.868764846 15.5755102,2.33194774 15.5755102,4.14014252 C15.5755102,5.94833729 14.1387755,7.41152019 12.3632653,7.41152019 C10.5877551,7.41152019 9.15102041,5.94833729 9.15102041,4.14014252 C9.14693878,2.33610451 10.5877551,0.868764846 12.3632653,0.868764846 Z M16,13.1353919 L7.70204082,13.1353919 L5.79591837,6.45961995 L8.99183673,6.45961995 C9.72244898,7.55700713 10.9591837,8.28028504 12.3591837,8.28028504 C13.7591837,8.28028504 14.9959184,7.55700713 15.7265306,6.45961995 L18.722449,6.45961995 L16,13.1353919 Z"
                              id="Shape"></path>
                            <polygon id="Shape"
                              points="12.1886196 6 12.8461538 6 12.8461538 4.84615385 14 4.84615385 14 4.18545838 12.8461538 4.18545838 12.8461538 3 12.1886196 3 12.1886196 4.18545838 11 4.18545838 11 4.84615385 12.1886196 4.84615385">
                            </polygon>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> -->
  
                <span class="img-borders"> <img src="../../../assets/img/PIPTLE-BuyICON.png" class="sidebar-img" alt="">
                </span>
              </span> {{ 'Buy PIP'  }}</a>
              <!-- commented out | translate  -->
          </li>
  
          <li id="wire-nav"  (click)="navigateToWireTransfer()" >
            <a>
              <span class="side-icons">
  
                <!-- <svg width="19px" height="15px" viewBox="0 0 19 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
  
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Dashboard" transform="translate(-19.000000, -312.000000)" fill="#8E949C" fill-rule="nonzero">
                      <g id="Navigation" transform="translate(0.000000, 70.000000)">
                        <g id="transfer" transform="translate(19.000000, 242.000000)">
                          <path
                            d="M18.8013361,4.97239972 L14.0512541,0.199623099 C13.7862098,-0.0666076039 13.3565565,-0.0665277027 13.0915917,0.199782901 C12.9643975,0.327624776 12.8929477,0.500930416 12.8929079,0.681706816 L12.8929079,2.7271768 L8.1428259,2.7271768 C7.7680423,2.7271768 7.4642314,3.03243923 7.4642314,3.40901345 C7.4642314,3.78558767 7.7680423,4.09085009 8.1428259,4.09085009 L13.5715024,4.09085009 C13.946286,4.09085009 14.2500969,3.78558767 14.2500969,3.40901345 L14.2500969,2.32759105 L17.3620811,5.45444348 L14.2500969,8.58129592 L14.2500969,7.49991347 C14.2500969,7.12333925 13.946286,6.81807683 13.5715024,6.81807683 L6.10708215,6.81807683 L6.10708215,4.77260684 C6.10700263,4.39603262 5.80311221,4.09085009 5.42836837,4.09093 C5.24849132,4.09096995 5.07596999,4.16276115 4.948736,4.29056307 L0.198693759,9.06333969 C-0.066231253,9.32961034 -0.066231253,9.76119652 0.198693759,10.0274272 L4.94877577,14.8002038 C5.07600975,14.9280857 5.24857084,14.9999568 5.42852741,14.9999967 C5.51771048,15.0002764 5.60609834,14.9826582 5.68840282,14.9481808 C5.94191654,14.8425515 6.10716167,14.593939 6.10708215,14.3181601 L6.10708215,12.2726901 L10.8571642,12.2726901 C11.2319478,12.2726901 11.5357587,11.9674277 11.5357587,11.5908534 C11.5357587,11.2142792 11.2319478,10.9090168 10.8571642,10.9090168 L5.42852741,10.9090168 C5.0537438,10.9090168 4.7499329,11.2142792 4.7499329,11.5908534 L4.7499329,12.6722359 L1.63794869,9.54538346 L4.7499329,6.41853102 L4.7499329,7.49991347 C4.7499329,7.87648769 5.0537438,8.18175012 5.42852741,8.18175012 L12.8929079,8.18175012 L12.8929079,10.2272201 C12.8929874,10.6037943 13.1968778,10.9089768 13.5716217,10.9088969 C13.7514987,10.908857 13.9240201,10.8370658 14.0512541,10.7092639 L18.8013361,5.93648725 C19.0662213,5.6702166 19.0662213,5.23863042 18.8013361,4.97239972 Z"
                            id="Shape"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> -->
                <span class="img-borders"> <img src="../../../assets/img/PIPTLE-WireTransferICON.png" class="sidebar-img" alt="">
                </span>
              </span> {{'Wire Transfer' | translate}}</a>
          </li>
  
          <li id="aff-nav" (click)="navigateToAffiliates()">
            <a>
              <span class="side-icons">
                <!-- <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
  
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Wire-transfer-popup" transform="translate(-18.000000, -361.000000)" fill="#8E949C"
                      fill-rule="nonzero">
                      <g id="Navigation" transform="translate(0.000000, 70.000000)">
                        <g id="affiliate" transform="translate(18.000000, 291.000000)">
                          <path
                            d="M12,18.6666667 C11.4485,18.6666667 11,18.3676667 11,18 C11,17.6323333 11.4485,17.3333333 12,17.3333333 C12.5515,17.3333333 13,17.6323333 13,18 L14,18 C14,17.3806667 13.36,16.863 12.5,16.714 L12.5,16 L11.5,16 L11.5,16.714 C10.64,16.863 10,17.3806667 10,18 C10,18.7353333 10.897,19.3333333 12,19.3333333 C12.5515,19.3333333 13,19.6323333 13,20 C13,20.3676667 12.5515,20.6666667 12,20.6666667 C11.4485,20.6666667 11,20.3676667 11,20 L10,20 C10,20.6193333 10.64,21.137 11.5,21.286 L11.5,22 L12.5,22 L12.5,21.286 C13.36,21.137 14,20.6193333 14,20 C14,19.2646667 13.103,18.6666667 12,18.6666667 Z"
                            id="Shape"></path>
                          <path
                            d="M22.4516129,9.43819355 L22.4516129,3.87096774 C22.4516129,1.73651613 20.7150968,0 18.5806452,0 C16.4461935,0 14.7096774,1.73651613 14.7096774,3.87096774 L14.7096774,9.43819355 C13.8123871,9.62167742 13.1612903,10.4171613 13.1612903,11.3338065 L13.1612903,12.3870968 L18.5806452,12.3870968 L18.5806452,18.1935484 C18.5806452,18.4068387 18.4068387,18.5806452 18.1935484,18.5806452 L17.0125161,18.5806452 C16.8139355,15.9867097 14.6442581,13.9354839 12,13.9354839 C9.35574194,13.9354839 7.18606452,15.9867097 6.98748387,18.5806452 L5.80645161,18.5806452 C5.59316129,18.5806452 5.41935484,18.4068387 5.41935484,18.1935484 L5.41935484,12.3870968 L10.8387097,12.3870968 L10.8387097,11.3338065 C10.8387097,10.4144516 10.1845161,9.61625806 9.28296774,9.43587097 L6.96774194,8.97290323 L6.96774194,8.41393548 C7.35522581,8.14296774 7.66722581,7.77329032 7.87006452,7.34167742 C8.66322581,7.27548387 9.29032258,6.61625806 9.29032258,5.80645161 L9.29032258,3.87096774 C9.29032258,1.73651613 7.55380645,0 5.41935484,0 C3.28490323,0 1.5483871,1.73651613 1.5483871,3.87096774 L1.5483871,5.80645161 C1.5483871,6.61625806 2.17548387,7.27548387 2.96864516,7.34167742 C3.17187097,7.77329032 3.48348387,8.14296774 3.87096774,8.41393548 L3.87096774,8.97290323 L1.55574194,9.43587097 C0.654193548,9.61625806 0,10.4144516 0,11.3338065 L0,12.3870968 L4.64516129,12.3870968 L4.64516129,18.1935484 C4.64516129,18.8338065 5.16619355,19.3548387 5.80645161,19.3548387 L6.98748387,19.3548387 C7.18606452,21.9487742 9.35574194,24 12,24 C13.2069677,24 14.3744516,23.5660645 15.2872258,22.7779355 L14.7812903,22.191871 C14.0090323,22.8588387 13.0211613,23.2258065 12,23.2258065 C9.65225806,23.2258065 7.74193548,21.3154839 7.74193548,18.9677419 C7.74193548,16.62 9.65225806,14.7096774 12,14.7096774 C14.3477419,14.7096774 16.2580645,16.62 16.2580645,18.9677419 C16.2580645,19.9494194 15.9336774,20.8714839 15.3193548,21.6348387 L15.9228387,22.1202581 C16.5572903,21.3313548 16.9374194,20.3616774 17.0156129,19.3548387 L18.1935484,19.3548387 C18.8338065,19.3548387 19.3548387,18.8338065 19.3548387,18.1935484 L19.3548387,12.3870968 L24,12.3870968 L24,11.3338065 C24,10.4171613 23.3489032,9.62167742 22.4516129,9.43819355 Z M8.11316129,6.48154839 C8.12322581,6.38670968 8.12903226,6.29070968 8.12903226,6.19354839 L8.12903226,5.13987097 C8.35935484,5.27419355 8.51612903,5.52116129 8.51612903,5.80645161 C8.51612903,6.09832258 8.352,6.34954839 8.11316129,6.48154839 Z M2.32258065,5.80645161 C2.32258065,5.52116129 2.47935484,5.27419355 2.70967742,5.13987097 L2.70967742,6.19354839 C2.70967742,6.29070968 2.71548387,6.38670968 2.72554839,6.48154839 C2.48670968,6.34954839 2.32258065,6.09832258 2.32258065,5.80645161 Z M2.76967742,4.29445161 C2.60903226,4.32929032 2.4603871,4.39316129 2.32258065,4.47329032 L2.32258065,3.87096774 C2.32258065,2.16348387 3.71187097,0.774193548 5.41935484,0.774193548 C7.12683871,0.774193548 8.51612903,2.16348387 8.51612903,3.87096774 L8.51612903,4.47329032 C8.37832258,4.39277419 8.22967742,4.32890323 8.06903226,4.29406452 C7.91922581,3.82606452 7.48490323,3.48387097 6.96774194,3.48387097 L3.87096774,3.48387097 C3.35380645,3.48387097 2.91948387,3.82606452 2.76967742,4.29445161 Z M3.48387097,6.19354839 L3.48387097,4.64516129 C3.48387097,4.43187097 3.65767742,4.25806452 3.87096774,4.25806452 L6.96774194,4.25806452 C7.18103226,4.25806452 7.35483871,4.43187097 7.35483871,4.64516129 L7.35483871,6.19354839 C7.35483871,7.26077419 6.48658065,8.12903226 5.41935484,8.12903226 C4.35212903,8.12903226 3.48387097,7.26077419 3.48387097,6.19354839 Z M6.19354839,8.78903226 L6.19354839,9.13006452 L5.41935484,9.90425806 L4.64516129,9.13006452 L4.64516129,8.78903226 C4.89058065,8.86258065 5.15032258,8.90322581 5.41935484,8.90322581 C5.6883871,8.90322581 5.94812903,8.86258065 6.19354839,8.78903226 Z M0.774193548,11.6129032 L0.774193548,11.3338065 C0.774193548,10.7821935 1.16670968,10.3033548 1.70787097,10.1949677 L4.13109677,9.71032258 L5.41935484,10.9989677 L6.708,9.71032258 L9.13122581,10.1949677 C9.672,10.3033548 10.0645161,10.7821935 10.0645161,11.3338065 L10.0645161,11.6129032 L0.774193548,11.6129032 Z M15.483871,3.87096774 C15.483871,2.16348387 16.8731613,0.774193548 18.5806452,0.774193548 C20.288129,0.774193548 21.6774194,2.16348387 21.6774194,3.87096774 L21.6774194,4.47329032 C21.5574194,4.40322581 21.428129,4.34864516 21.2903226,4.31303226 L21.2903226,3.87096774 L20.9032258,3.87096774 C20.2579355,3.87096774 19.6509677,3.61974194 19.1945806,3.16335484 L18.5806452,2.54941935 L17.9667097,3.16335484 C17.5103226,3.61974194 16.9033548,3.87096774 16.2580645,3.87096774 L15.8709677,3.87096774 L15.8709677,4.31303226 C15.7331613,4.34903226 15.603871,4.40322581 15.483871,4.47329032 L15.483871,3.87096774 Z M18.5806452,8.12903226 C17.5134194,8.12903226 16.6451613,7.26077419 16.6451613,6.19354839 L16.6451613,4.62193548 C17.3508387,4.53716129 18.003871,4.22090323 18.5140645,3.71070968 L18.5806452,3.64412903 L18.6472258,3.71070968 C19.1574194,4.22090323 19.8104516,4.53716129 20.516129,4.62193548 L20.516129,6.19354839 C20.516129,7.26077419 19.647871,8.12903226 18.5806452,8.12903226 Z M19.3548387,8.78903226 L19.3548387,9.13006452 L18.5806452,9.90425806 L17.8064516,9.13006452 L17.8064516,8.78903226 C18.051871,8.86258065 18.3116129,8.90322581 18.5806452,8.90322581 C18.8496774,8.90322581 19.1094194,8.86258065 19.3548387,8.78903226 Z M20.1290323,8.41393548 C20.5165161,8.14296774 20.8285161,7.77329032 21.0313548,7.34167742 C21.2659355,7.32193548 21.4842581,7.25187097 21.6774194,7.13922581 L21.6774194,9.28258065 L20.1290323,8.97290323 L20.1290323,8.41393548 Z M21.2744516,6.48154839 C21.2845161,6.38670968 21.2903226,6.29070968 21.2903226,6.19354839 L21.2903226,5.13987097 C21.5206452,5.27419355 21.6774194,5.52116129 21.6774194,5.80645161 C21.6774194,6.09832258 21.5132903,6.34954839 21.2744516,6.48154839 Z M15.8709677,5.13987097 L15.8709677,6.19354839 C15.8709677,6.29070968 15.8767742,6.38670968 15.8868387,6.48154839 C15.648,6.34954839 15.483871,6.09832258 15.483871,5.80645161 C15.483871,5.52116129 15.6406452,5.27419355 15.8709677,5.13987097 Z M15.483871,7.13922581 C15.6770323,7.25187097 15.8953548,7.32193548 16.1299355,7.34167742 C16.3331613,7.77329032 16.6447742,8.14296774 17.0322581,8.41393548 L17.0322581,8.97290323 L15.483871,9.28258065 L15.483871,7.13922581 Z M23.2258065,11.6129032 L13.9354839,11.6129032 L13.9354839,11.3338065 C13.9354839,10.7821935 14.328,10.3033548 14.8691613,10.1949677 L17.2923871,9.71032258 L18.5806452,10.9989677 L19.8692903,9.71032258 L22.2925161,10.1949677 C22.8332903,10.3033548 23.2258065,10.7821935 23.2258065,11.3338065 L23.2258065,11.6129032 Z"
                            id="Shape"></path>
                          <rect id="Rectangle-path" x="18" y="20" width="1" height="1"></rect>
                          <rect id="Rectangle-path" x="20" y="20" width="1" height="1"></rect>
                          <rect id="Rectangle-path" x="22" y="20" width="1" height="1"></rect>
                          <rect id="Rectangle-path" x="1" y="20" width="1" height="1"></rect>
                          <rect id="Rectangle-path" x="3" y="20" width="1" height="1"></rect>
                          <rect id="Rectangle-path" x="5" y="20" width="1" height="1"></rect>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> -->
                <span class="img-borders"> <img src="../../../assets/img/PIPTLE-ReferralICON.png" class="sidebar-img" alt="">
                </span>
              </span> {{'Referral Program' | translate}}</a>
          </li>
  
  
  
  
          <li id="faqs-nav" (click)="navigateToFaqs()">
            <a>
              <span class="side-icons">
                <!-- <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
  
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Dashboard" transform="translate(-20.000000, -413.000000)" fill="#8E949C" fill-rule="nonzero">
                      <g id="Navigation" transform="translate(0.000000, 70.000000)">
                        <g id="faq" transform="translate(20.000000, 343.000000)">
                          <path
                            d="M10,3 C8.89699299,3 8,3.89694612 8,5 C8,6.10305388 8.89694612,7 10,7 C11.1030539,7 12,6.10305388 12,5 C12,3.89694612 11.103007,3 10,3 Z M10,6 C9.44874139,6 9,5.55125861 9,5 C9,4.44874139 9.44874139,4 10,4 C10.5512586,4 11,4.44874139 11,5 C11,5.55125861 10.5512586,6 10,6 Z"
                            id="Shape"></path>
                          <path
                            d="M11.4999438,8 L7.50000937,8 C7.22363783,8 7,8.18297765 7,8.40910137 L7,10.0454685 C7,10.2715922 7.22363783,10.4545699 7.50000937,10.4545699 L8.00001875,10.4545699 L8.00001875,16.5908986 C8.00001875,16.8170223 8.22365658,17 8.50002812,17 L11.4999906,17 C11.7763622,17 12,16.8170223 12,16.5908986 L12,8.40910137 C11.9999531,8.18297765 11.7763153,8 11.4999438,8 Z M10.9999344,16.1817589 L8.99994375,16.1817589 L8.99994375,10.0454301 C8.99994375,9.81930642 8.77630592,9.63632877 8.49993438,9.63632877 L7.999925,9.63632877 L7.999925,8.81816439 L10.9998875,8.81816439 L10.9998875,16.1817589 L10.9999344,16.1817589 Z"
                            id="Shape"></path>
                          <path
                            d="M10,0 C4.48609375,0 0,4.48609375 0,10 C0,15.5139062 4.48609375,20 10,20 C15.5139062,20 20,15.5139062 20,10 C20,4.48609375 15.5139062,0 10,0 Z M10,19.1666797 C4.94546875,19.1666797 0.833320313,15.0545312 0.833320313,10 C0.833320313,4.94546875 4.94546875,0.833320313 10,0.833320313 C15.0545312,0.833320313 19.1666797,4.94546875 19.1666797,10 C19.1666797,15.0545312 15.0545312,19.1666797 10,19.1666797 Z"
                            id="Shape"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> -->
                <span class="img-borders"> <img src="../../../assets/img/PIPTLE-FAQ-ICON.png" class="sidebar-img" alt="">
                </span>
              </span> {{'FAQ' | translate}}</a>
          </li>
  
  
          <ul class="left-right">
  
            <!-- <li class="nav-item">
    
              <div class="notifications">
                <button class="notification-btn" (click)="openMailer()">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19px"
                    height="12px">
                    <image x="0px" y="0px" width="19px" height="12px"
                      xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAMCAMAAAC3DnawAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAqFBMVEVYc4f///9Yc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4f///8bVa4WAAAANnRSTlMAADy7ghwO8ZVoDdt5fvYS2m5WtEbHdKk+3zCNkBbsaZ8oxIgR51ucLOGdL/uBfSL0nvfw8vW1p76NAAAAAWJLR0QB/wIt3gAAAAd0SU1FB+IHEhM3NHC7GoUAAACDSURBVAjXZc7XDoJQAIPhH0VxIu6990bFvv+jeQ6KkdibJl/SpOg/kElD1nFwc3nvhwpOUUglyl+qUJU1v0bwoTquYpMaNGNq0VZiHeia6kE/sQHBkJHGTKbM3jZnIS1htZY2bK3t2NvB4XiydXYu5vM1TH2+mc+66xGZhL4XKfKehl8JPiQd/HYZLgAAAABJRU5ErkJggg==" />
                  </svg>
                </button>
              </div>
    
    
            </li> -->
  
            <li class="nav-item">
              <div class="notifications">
                <button type="button" class="dropdown-toggle notification-btn" data-toggle="dropdown"
                  onclick="zE.activate();">
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22px"
                    height="19px">
                    <image x="0px" y="0px" width="22px" height="19px"
                      xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAMAAACjpw26AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA7VBMVEVYc4f///9Yc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4f////ilIfjAAAATXRSTlMAAAdwxPPkpklg8sIdfPsjQOICxfza4+rW+N5SDPnmDlfKgwj2e/dhh6peeYaTvCpZMs5+X6AWonMERhgBVtUXFfCSWOApBt/1HhHMiMMpqmYAAAABYktHRAH/Ai3eAAAAB3RJTUUH4gYbCgAkrpRUEAAAANVJREFUGNNt0OtSwjAQBeATpEUoIEJRbiJKVUABuVdBvKKinPd/HTcGmHam50823yQ7yQJA7CBukbQTh7JR/5EimeIuTnrPGQaSPdpyjqEc5w0XSLd4wtNSmaWKeDVW03xG1nHOBi4ICF82vSvha9K6abHdsdm5Fb5TZFehF+7NvjDvMQjrUI30AoyDWkdaL658J/DECaYWzWlgZqzgP6BhyrboI505sJDqaWnUfQZeXt/0lfcPd99rpUeV04pP/2unZoLhqG+uo/jn18tHsFIbFckywj9ElD8N3HLQcgAAAABJRU5ErkJggg==" />
                  </svg> -->
                  <span class="img-borders"> <img src="../../../assets/img/PIPTLE - MessageICON.png" class="sidebar-img" alt="">
                  </span>
                </button>
  
  
              </div>
            </li>
  
            <!-- <li class="nav-item">
                        <div class="notifications">
                            <div class="notification-count">
                                <p class="count">3</p>
                            </div>
                            <button class="notification-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22px"
                                    height="19px">
                                    <image x="0px" y="0px" width="22px" height="19px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAMAAACjpw26AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA7VBMVEVYc4f///9Yc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4f////ilIfjAAAATXRSTlMAAAdwxPPkpklg8sIdfPsjQOICxfza4+rW+N5SDPnmDlfKgwj2e/dhh6peeYaTvCpZMs5+X6AWonMERhgBVtUXFfCSWOApBt/1HhHMiMMpqmYAAAABYktHRAH/Ai3eAAAAB3RJTUUH4gYbCgAkrpRUEAAAANVJREFUGNNt0OtSwjAQBeATpEUoIEJRbiJKVUABuVdBvKKinPd/HTcGmHam50823yQ7yQJA7CBukbQTh7JR/5EimeIuTnrPGQaSPdpyjqEc5w0XSLd4wtNSmaWKeDVW03xG1nHOBi4ICF82vSvha9K6abHdsdm5Fb5TZFehF+7NvjDvMQjrUI30AoyDWkdaL658J/DECaYWzWlgZqzgP6BhyrboI505sJDqaWnUfQZeXt/0lfcPd99rpUeV04pP/2unZoLhqG+uo/jn18tHsFIbFckywj9ElD8N3HLQcgAAAABJRU5ErkJggg==" />
                                </svg>
                            </button>
                        </div>
                    </li> -->
  
            <li class="nav-item">
              <div class="dropdown">
                <div class="notification-count" *ngIf="notificationCount != 0">
                  <p class="count">{{notificationCount}}</p>
                </div>
                <button class="notification-btn" (click)="fetchNotifications()">
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px"
                    height="16px">
                    <image x="0px" y="0px" width="16px" height="16px"
                      xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAbFBMVEVYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4dYc4f///9Szu4AAAAAInRSTlMAJMzLIAKe/vuZycp4et/mARH8GRcP9w4Wdn1NUDM0VttZBjyCeAAAAAFiS0dEIypibDoAAAAHdElNRQfiBhsJOzJktLAgAAAAYUlEQVQY022N1w6AMAgAcda996z8/0eaUjui3hN3hABAOK7ngyEIGWIUBzokSKTKM3zIn1CoUFbkdaMCthS6SAf5qR+Us47CaE4mCrN2XISvaLHBF3wB/+xid9jl5PyS0w1XOQ/6mKyj9QAAAABJRU5ErkJggg==" />
                  </svg>  -->
                  <span class="img-borders"> <img src="../../../assets/img/PIPTLE-AlarmICON1.png" class="sidebar-img" alt="">
                  </span>
                </button>
  
                <div class="dropdown-menu notifications-tab">
  
                  <div class="pointy-up">
                  </div>
                  <ul class="notifications-list">
                    <li class="no-hover" style="margin: 0 !important;" *ngIf="notificationsLoader">
                      <div class="box-loader">
                        <div class="center-loader">
                          <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                            preserveAspectRatio="xMidYMid">
                            <g transform="rotate(208.756 50 50)">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite"
                                values="360 50 50;0 50 50" keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5"
                                calcMode="spline"></animateTransform>
                              <path fill="#85ffbd"
                                d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                              </path>
                              <path fill="#316598"
                                d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                              </path>
                              <path fill="#a4bcc2"
                                d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                              </path>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </li>
  
                    <div class="clearfix" *ngIf="notificationList.length == 0">
                      <div class="not-inner">
                        <p class="no-notifications text-centered">No Notifications</p>
                      </div>
                    </div>
  
                    <ng-container *ngFor="let nott of notificationList">
  
  
                      <li *ngIf="nott.NotificationType == 'WIRE_TRANSFER_APPROVE_REJECTION'"
                        [ngClass]="{'unreadNotification': nott.IsRead==false}"
                        (click)="updateNotificationStatus(nott._id)">
                        <div class="clearfix">
                          <div class="not-icon-left">
                            <svg width="19px" height="15px" viewBox="0 0 19 15" version="1.1"
                              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  
                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Dashboard" transform="translate(-19.000000, -312.000000)" fill="#8E949C"
                                  fill-rule="nonzero">
                                  <g id="Navigation" transform="translate(0.000000, 70.000000)">
                                    <g id="transfer" transform="translate(19.000000, 242.000000)">
                                      <path
                                        d="M18.8013361,4.97239972 L14.0512541,0.199623099 C13.7862098,-0.0666076039 13.3565565,-0.0665277027 13.0915917,0.199782901 C12.9643975,0.327624776 12.8929477,0.500930416 12.8929079,0.681706816 L12.8929079,2.7271768 L8.1428259,2.7271768 C7.7680423,2.7271768 7.4642314,3.03243923 7.4642314,3.40901345 C7.4642314,3.78558767 7.7680423,4.09085009 8.1428259,4.09085009 L13.5715024,4.09085009 C13.946286,4.09085009 14.2500969,3.78558767 14.2500969,3.40901345 L14.2500969,2.32759105 L17.3620811,5.45444348 L14.2500969,8.58129592 L14.2500969,7.49991347 C14.2500969,7.12333925 13.946286,6.81807683 13.5715024,6.81807683 L6.10708215,6.81807683 L6.10708215,4.77260684 C6.10700263,4.39603262 5.80311221,4.09085009 5.42836837,4.09093 C5.24849132,4.09096995 5.07596999,4.16276115 4.948736,4.29056307 L0.198693759,9.06333969 C-0.066231253,9.32961034 -0.066231253,9.76119652 0.198693759,10.0274272 L4.94877577,14.8002038 C5.07600975,14.9280857 5.24857084,14.9999568 5.42852741,14.9999967 C5.51771048,15.0002764 5.60609834,14.9826582 5.68840282,14.9481808 C5.94191654,14.8425515 6.10716167,14.593939 6.10708215,14.3181601 L6.10708215,12.2726901 L10.8571642,12.2726901 C11.2319478,12.2726901 11.5357587,11.9674277 11.5357587,11.5908534 C11.5357587,11.2142792 11.2319478,10.9090168 10.8571642,10.9090168 L5.42852741,10.9090168 C5.0537438,10.9090168 4.7499329,11.2142792 4.7499329,11.5908534 L4.7499329,12.6722359 L1.63794869,9.54538346 L4.7499329,6.41853102 L4.7499329,7.49991347 C4.7499329,7.87648769 5.0537438,8.18175012 5.42852741,8.18175012 L12.8929079,8.18175012 L12.8929079,10.2272201 C12.8929874,10.6037943 13.1968778,10.9089768 13.5716217,10.9088969 C13.7514987,10.908857 13.9240201,10.8370658 14.0512541,10.7092639 L18.8013361,5.93648725 C19.0662213,5.6702166 19.0662213,5.23863042 18.8013361,4.97239972 Z"
                                        id="Shape"></path>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="not-inner">
                            <p class="notification-line">{{nott.NotificationText}}</p>
                          </div>
                          <div class="abs-time">
                            {{nott.CreatedOnUTC}}
                          </div>
                        </div>
                      </li>
  
                      <li *ngIf="nott.NotificationType == 'Transaction_Confirmation'"
                        [ngClass]="{'unreadNotification': nott.IsRead==false}"
                        (click)="updateNotificationStatus(nott._id)">
                        <div class="clearfix">
                          <div class="not-icon-left">
                            <img src="../../../assets/img/transaction.png">
                          </div>
                          <div class="not-inner">
                            <p class="notification-line">{{nott.NotificationText}}</p>
                          </div>
                          <div class="abs-time">
                            {{nott.CreatedOnUTC}}
                          </div>
                        </div>
                      </li>
                      <li *ngIf="nott.NotificationType == 'KYC_Approval'"
                        [ngClass]="{'unreadNotification': nott.IsRead==false}"
                        (click)="updateNotificationStatus(nott._id)">
                        <div class="clearfix">
                          <div class="not-icon-left">
                            <img src="../../../assets/img/kyc.png">
                          </div>
                          <div class="not-inner">
                            <p class="notification-line">{{nott.NotificationText}}</p>
                          </div>
                          <div class="abs-time">
                            {{nott.CreatedOnUTC}}
                          </div>
                        </div>
                      </li>
                      <li *ngIf="nott.NotificationType == 'ICO_Stage_Updation'"
                        [ngClass]="{'unreadNotification': nott.IsRead==false}"
                        (click)="updateNotificationStatus(nott._id)">
                        <div class="clearfix">
                          <div class="not-icon-left">
                            <img src="../../../assets/img/ico-stage.png">
                          </div>
                          <div class="not-inner">
                            <p class="notification-line">{{nott.NotificationText}}</p>
                          </div>
                          <div class="abs-time">
                            {{nott.CreatedOnUTC}}
                          </div>
                        </div>
                      </li>
                      <li *ngIf="nott.NotificationType === 'AFFILIATION_TRANSACTION'"
                        [ngClass]="{'unreadNotification': nott.IsRead==false}"
                        (click)="updateNotificationStatus(nott._id)">
                        <div class="clearfix">
                          <div class="not-icon-left">
                            <img src="../../../assets/img/reward.png">
                          </div>
                          <div class="not-inner">
                            <p class="notification-line">{{nott.NotificationText}}</p>
                          </div>
                          <div class="abs-time">
                            {{nott.CreatedOnUTC}}
                          </div>
                        </div>
                      </li>
  
                      <li *ngIf="nott.NotificationType === 'AFFILIATION_REGISTRATION'"
                        [ngClass]="{'unreadNotification': nott.IsRead==false}"
                        (click)="updateNotificationStatus(nott._id)">
                        <div class="clearfix">
                          <div class="not-icon-left">
                            <img src="../../../assets/img/affiliate.png">
                          </div>
                          <div class="not-inner">
                            <p class="notification-line">{{nott.NotificationText}}</p>
                          </div>
                          <div class="abs-time">
                            {{nott.CreatedOnUTC}}
                          </div>
                        </div>
                      </li>
                    </ng-container>
  
                    <div class="clearfix">
                      <div class="not-inner">
                        <p class="see-all-btn text-centered" style="cursor:pointer"
                          (click)="navigateToNotificationsList()">
                          See
                          All
                        </p>
                      </div>
                    </div>
  
                  </ul>
  
                </div>
              </div>
  
  
            </li>
          </ul>
  
  
        </ul>
  
        <hr class="sidebar-hr" />
  
        <!-- <div class="search-bar-search">
                <div class='search-wrapper'>
                    <div class='btn'>
                        <button class="search">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                    <input type="text" class="input-search" placeholder="Search">
                </div>
            </div> -->
  
        <ul class="dropdown">
          <div class="dropdown profile-dropdown-wrapper-sidebar">
            <button type="button" class="dropdown-toggle profile-drop-side" data-toggle="dropdown">
  
              <div class="clearfix">
  
  
                <div class="centered-image">
                  <div class="rounded-image-box margin-auto">
                    <!-- <img [routerLink]="['/home/settings']" src="../../../assets/img/shirley.png"> -->
                    <span class="profile-borders"> 
                      <img [routerLink]="['/home/settings']" src="../../../assets/img/PIPTLE-ProfileICON.png" class="profile-img" alt="">
                    </span>
                  </div>
                </div>
                <div class="profile-section">
                  <!-- <p [routerLink]="['/home/settings']" class="actual-name custome-menu text-color bold">
                    {{userObject.UserName}}
  
                  </p> -->
                  <p [routerLink]="['/home/settings']" class="profile-txt">MY SETTINGS</p>
                </div>
  
              </div>
            </button>
            <p class="profile-txt text-center">{{userName}}</p>

            <hr class="sidebar-hr">

            <div class="logout-sec">
              <p class="log-out" (click)="logout()">{{'Logout' | translate}}</p>
            </div>

            <div class='extra-side'>
              <ul class="profile-list" style="height: 85px;">
                <!-- <li class="cursor" (click)="NavigateToSettings()" id="settings-small">
                  <div class="clearfix cursor">
                    <div class="left-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px"
                        height="20px">
                        <image x="0px" y="0px" width="20px" height="20px"
                          xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBhoMHQ42cuoNAAABWUlEQVQoz2XSvWtVQRAF8JOoiBYhiC/BWGiIRSzUWmxEEAk2RhAbTWMhmIekUATBLohYxErBSv0T7GzsLGJIY4IoUdEmifgBFhEFhZ/FW9+792am2D0zZ8/uHLZPGnE943mXO81y1HO/Tow26ukv/B2ZzWCS6YLbSVp5kIGm4jN8tKYXX61i/r9iZ5mpEF56ZLGCr1aJsQLeOFjwoCWwUleMD93iMt4aEQtY7xG32u4WOF6KT7EqDoM5ezvEG+Utn7tWnADbxKfSOyL9GS7jf0nyPOeSXEuSDCX5VnoDSW/iH6JN16K74nvZj0ls0acNzoonFWMumsOV+tQL2NASu4257C+YMKtVJ74GP00WfLKoHqv7eKFy4S/v8diZgo/WFe/hlReVA1NO9cxR+WaX7BHnS3NGxE3wxz6b/uNOv8F4wbfBhukmMXY5ZKiCH2LZ6c3EZg6774D8AxlK7Tt5GVv7AAAAAElFTkSuQmCC" />
                      </svg>
                    </div>
                    <div class="right-name">
                      <p class="text-color bold">{{'Profile' | translate}}</p>
                    </div>
                  </div>
                </li> -->
  
  
  
  
                <!-- <li (click)="navigateToFaqs()">
    
                  <div class="clearfix cursor">
                    <div class="left-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px"
                        height="18px">
                        <image x="0px" y="0px" width="18px" height="18px"
                          xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBhoMIQis4jbHAAABA0lEQVQoz2WSsUoDQRCGvztMJYLChfRCCi2ECGcRLNOmsLDzCaxtbC1EfAJbBQUfwE5JmxAQAjHN2ahIGgshNgnmfovcHjPx32bnm5/dmZ2NhNEOTRKmZDwxMVxhHepDVndKQi5YHsrkXLcaFvuWNXXMCQsS1A6mM3cNQldl9K11gTb040y5chefC3RkQLcoNjPsRcTsm1YnfAGr1AzbZiumbkCLCyBlzT4etZhfB3pAipdiRg48A7tLpnd0YIrMhNCr664vUEXjEtwL1eV1snjM4xLcCKHUWN60EsZyXaDp0lByNeyAL/VfY236X4AaejSGT50qCrnIfbqEParMGDGw+A+3VnAmUZWGhgAAAABJRU5ErkJggg==" />
                      </svg>
                    </div>
                    <div class="right-name">
                      <p class="text-color">FAQ</p>
                    </div>
                  </div>
    
    
    
    
                </li> -->
  
  
                <!-- <li (click)="logout()">
  
                  <div class="clearfix cursor"> -->
                    <!-- <div class="left-icon" style="text-align: center;">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px"
                        height="15px">
                        <image x="0px" y="0px" width="18px" height="15px"
                          xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAMAAADeWG8gAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAY1BMVEX///+jssf///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+jsseNoU6pAAAAH3RSTlMAABSmowTA/M0M2xHtJPdDBVb1OgLnHdUJCga3C5gH9fLnCAAAAAFiS0dEAIgFHUgAAAAHdElNRQfiBhoMIR3BP9IsAAAAX0lEQVQY02XPVw7AIAwDULro3nua+5+yUklABX9Fz1KUCCHwRdiEiiliAmI9JJCGuEyR5ZZAKUqPUNUeoWk7l4DepWGcHJoXd9e6/e8C5E6D0nLgpO4yP97m74DpIXgB318QYzdytmQAAAAASUVORK5CYII=" />
                      </svg>
                    </div> -->
                    <!-- <div class="right-name">
                      <p class="text-color bold">{{'Logout' | translate}}</p>
                    </div>
                  </div> -->
  
  
                <!-- </li> -->
  
              </ul>
            </div>
  
            <div id="sidebar-icon" style="height: 120px;">
              <ul class="social-icon-list-sidebar">
                <li class="text-center mr-2">
                  <a href="https://www.facebook.com/piptle/" class="icon-borders p-0 side-social-icons" target="_blank">
                      <img src="../../../assets//img//PIPTLE-Facebook-F-Icon.png" alt="fb-icon" class="icon-img">
                  </a>
                </li>
                <li class="text-center mr-2">
                  <a href="https://twitter.com/piptleit" class="icon-borders side-social-icons p-0" target="_blank">
                    <!-- <img src="../../../assets//img/twitter-ico.png" alt="twitter-icon"> -->
                      <img src="../../../assets//img//PIPTLE-TwitterIcon.png" alt="twitter-icon" class="icon-img">
                  </a>
                </li>
                <li class="text-center mr-2">
                  <a href="https://www.instagram.com/piptleit/" target="_blank" class="icon-borders side-social-icons p-0">
                    <!-- <img src="../../../assets//img/insta-ico.png" alt="instagram-icon"> -->
                      <img src="../../../assets//img//PIPTLE-InstagramIcon.png" alt="instagram-icon" class="icon-img">
                  </a>
                </li>
                <li class="text-center mr-2">
                  <a href="https://t.me/piptler" target="_blank" class="icon-borders p-0 side-social-icons">
                    <!-- <img src="../../../assets//img/insta-ico.png" alt="instagram-icon"> -->
                      <img src="../../../assets//img//telegram icon.png" alt="telegram-icon" class="icon-telegram">
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </ul>
  
  
      </div>
  
  
  
  
  
  
  
  
    </nav>
  </div>
  <!-- Page Content -->
  <div id="content">

    <router-outlet></router-outlet>

  </div>
</div>